import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#1d8633" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Partner With a Leading Software Development Company Los Angeles
            </h2>
            <p>
              As the premier IoT software development company Los Angeles,
              TekRevol has worked with hundreds of global businesses, including
              startups and conglomerates as big as Fortune 100 companies. Our
              PMP-certified project managers work tirelessly to ensure the
              software quality and user experience exceed the stakeholders'
              expectations.
            </p>
            <p>
              We, as a highly reputable software company in Los Angeles, ensure
              that every development stage passes the utmost quality check
              successfully. With Agile methodology at the heart of our
              development process, every development step gets validation from
              the stakeholders before we move on to the next one.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#1d8633",
                border: "1px solid #1d8633",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Free Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <StaticImage
              src="../../images/location_new/fold5/partner-los-angeles.webp"
              alt="los-angeles"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={866}
              height={1042}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
